import { SmartComponent } from "smart-component-js";

class SearchComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.input = this.element.querySelector('.search-bar__input');
    this.init();
  }

  goToSearch() {
    const keyword = this.input.value;
    if(!keyword) return;
    window.location.href = `${GENERIC_TRANSLATIONS.genericSearchLink}?keyword=${encodeURIComponent(keyword)}`;
  }

  closeOverlay() {
    this.element.classList.remove('visible');
  }

  init() {
    const closeButton = this.element.querySelector(".search-overlay__close-button");
    closeButton.addEventListener("click", () => this.closeOverlay());

    const searchButton = this.element.querySelector('.search-bar__button');
    searchButton.addEventListener('click', () => this.goToSearch());
  }
}

export default SearchComponent;
